import { FC } from 'react';
import { Radio } from '../../../components/Radio';
import {
  updateQuestionChoice,
  useCurrentAnswer,
  useCurrentChoices,
  useCurrentQuestion,
} from '../../../services/inspection';
import { ClosedAnswerState, ClosedQuestion } from '../types';

interface ChoiceInputProps {}

export const ChoiceInput: FC<ChoiceInputProps> = () => {
  const question = useCurrentQuestion() as ClosedQuestion;
  const answer = useCurrentAnswer() as ClosedAnswerState;
  const choices = useCurrentChoices();

  return (
    <div>
      {choices.map(({ id, text }) => (
        <Radio
          key={id}
          name="radio"
          onChange={(e) => updateQuestionChoice(question.id, e.target.value)}
          value={id}
          checked={id === answer.choice}
        >
          {text}
        </Radio>
      ))}
    </div>
  );
};
